__turbopack_context__.v({
  "empty": "CCrmProjectManagement-module__KI2yqq__empty",
  "feature": "CCrmProjectManagement-module__KI2yqq__feature",
  "featureIcon": "CCrmProjectManagement-module__KI2yqq__featureIcon",
  "features": "CCrmProjectManagement-module__KI2yqq__features",
  "intro": "CCrmProjectManagement-module__KI2yqq__intro",
  "order": "CCrmProjectManagement-module__KI2yqq__order",
  "orderAccount": "CCrmProjectManagement-module__KI2yqq__orderAccount",
  "orderAccountName": "CCrmProjectManagement-module__KI2yqq__orderAccountName",
  "orderActions": "CCrmProjectManagement-module__KI2yqq__orderActions",
  "orderFields": "CCrmProjectManagement-module__KI2yqq__orderFields",
  "orderFieldset": "CCrmProjectManagement-module__KI2yqq__orderFieldset",
  "orderForm": "CCrmProjectManagement-module__KI2yqq__orderForm",
  "orderGus": "CCrmProjectManagement-module__KI2yqq__orderGus",
  "orderGusMessage": "CCrmProjectManagement-module__KI2yqq__orderGusMessage",
  "orderHeader": "CCrmProjectManagement-module__KI2yqq__orderHeader",
  "orderHint": "CCrmProjectManagement-module__KI2yqq__orderHint",
  "orderLegend": "CCrmProjectManagement-module__KI2yqq__orderLegend",
  "orderLogin": "CCrmProjectManagement-module__KI2yqq__orderLogin",
  "orderLoginBox": "CCrmProjectManagement-module__KI2yqq__orderLoginBox",
  "orderPaymentLink": "CCrmProjectManagement-module__KI2yqq__orderPaymentLink",
  "orderRadios": "CCrmProjectManagement-module__KI2yqq__orderRadios",
  "orderRegulaminText": "CCrmProjectManagement-module__KI2yqq__orderRegulaminText",
  "orderSummary": "CCrmProjectManagement-module__KI2yqq__orderSummary",
  "orderSummaryLabel": "CCrmProjectManagement-module__KI2yqq__orderSummaryLabel",
  "orderSummaryTrial": "CCrmProjectManagement-module__KI2yqq__orderSummaryTrial",
  "orderSummaryValue": "CCrmProjectManagement-module__KI2yqq__orderSummaryValue",
  "orderTitle": "CCrmProjectManagement-module__KI2yqq__orderTitle",
  "orderTrial": "CCrmProjectManagement-module__KI2yqq__orderTrial",
  "orderTrialBody": "CCrmProjectManagement-module__KI2yqq__orderTrialBody",
  "orderTrialIcon": "CCrmProjectManagement-module__KI2yqq__orderTrialIcon",
  "orderTrialInner": "CCrmProjectManagement-module__KI2yqq__orderTrialInner",
  "orderTrialOn": "CCrmProjectManagement-module__KI2yqq__orderTrialOn",
  "orderTrialText": "CCrmProjectManagement-module__KI2yqq__orderTrialText",
  "orderTrialTitle": "CCrmProjectManagement-module__KI2yqq__orderTrialTitle",
  "package": "CCrmProjectManagement-module__KI2yqq__package",
  "packageAction": "CCrmProjectManagement-module__KI2yqq__packageAction",
  "packageBadges": "CCrmProjectManagement-module__KI2yqq__packageBadges",
  "packageCta": "CCrmProjectManagement-module__KI2yqq__packageCta",
  "packageDescription": "CCrmProjectManagement-module__KI2yqq__packageDescription",
  "packageHeader": "CCrmProjectManagement-module__KI2yqq__packageHeader",
  "packageName": "CCrmProjectManagement-module__KI2yqq__packageName",
  "packageRecommended": "CCrmProjectManagement-module__KI2yqq__packageRecommended",
  "packages": "CCrmProjectManagement-module__KI2yqq__packages",
  "price": "CCrmProjectManagement-module__KI2yqq__price",
  "priceHighlight": "CCrmProjectManagement-module__KI2yqq__priceHighlight",
  "priceMeta": "CCrmProjectManagement-module__KI2yqq__priceMeta",
  "priceNote": "CCrmProjectManagement-module__KI2yqq__priceNote",
  "priceSecondary": "CCrmProjectManagement-module__KI2yqq__priceSecondary",
  "priceTrial": "CCrmProjectManagement-module__KI2yqq__priceTrial",
  "priceValue": "CCrmProjectManagement-module__KI2yqq__priceValue",
  "root": "CCrmProjectManagement-module__KI2yqq__root",
  "type": "CCrmProjectManagement-module__KI2yqq__type",
  "typeDescription": "CCrmProjectManagement-module__KI2yqq__typeDescription",
  "typeHeader": "CCrmProjectManagement-module__KI2yqq__typeHeader",
  "typeName": "CCrmProjectManagement-module__KI2yqq__typeName",
});
